import classNames from "classnames";
import React from "react";
import { Logo } from "../../../../core/atoms";

export class TLRecommendRating extends React.PureComponent<{ rating: number }> {
  public render() {
    const rating = Math.round(Math.max(0, Math.min(5, this.props.rating)));

    return (
      <div className="tl-recommend-rating">
        <Logo width={75} type="light" />

        <h3>How likely are you to recommend TravelLocal?</h3>
        <div className="numbers">
          {[0, 1, 2, 3, 4, 5].map(x => <div key={x} className={classNames("number", { rated: rating === x })}>{x}</div>)}
        </div>
      </div>
    );
  }
}
